import {z} from "zod"
import {GraphNode} from "#graph/nodes/graph/node"
import {registerNode} from "#graph/decorators/register-node"
import type {Evaluator} from "#graph/evaluators/types"
import {ListDefinition} from "#graph/nodes/list/definition"
import type {ParameterValue} from "#graph/nodes/graph/validation"

export abstract class List<ItemType> extends GraphNode<ReturnType<typeof ListDefinition<ItemType>>> {
    static nodeClass = "List"
    static definition = ListDefinition(z.any())

    override run = async (evaluator: Evaluator): Promise<ItemType[]> => {
        return Promise.all(this.parameters.list.map((item) => evaluator.get(item)))
    }

    override runSync = (evaluator: Evaluator): ItemType[] => {
        return this.parameters.list.map((item) => evaluator.getSync(item))
    }

    addEntry(entry: ParameterValue<ItemType>) {
        const newList = [...this.parameters.list, entry]
        this.replaceParameters({list: newList})
    }

    removeEntry(entry: ParameterValue<ItemType>) {
        const {list} = this.parameters

        const index = list.indexOf(entry)
        if (index === -1) return

        const newList = [...list]
        newList.splice(index, 1)
        this.replaceParameters({list: newList})
    }

    clear() {
        this.replaceParameters({list: []})
    }
}

@registerNode
export class NumberList extends List<number> {
    static override nodeClass = "NumberList"
    static override definition = ListDefinition(z.number())
}

@registerNode
export class StringList extends List<string> {
    static override nodeClass = "StringList"
    static override definition = ListDefinition(z.string())
}
